import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { PackagesTypes } from '../actions/actions.types'

type PackagesState = ApplicationState['packages']

function packagesReducer(state: PackagesState = [], action: IAction): PackagesState {
	switch (action.type) {
		case PackagesTypes.GetPackages.SUCCESS:
			return action.payload
	}
	return state
}

export default packagesReducer
